/**
 * Copyright (c) Microsoft Corporation. All rights reserved.  
 * Licensed under the MIT License.
 */
import { ActionObject, UserState } from '../types'
import { AT } from '../types/ActionTypes'
import { Reducer } from 'redux'
import * as ClientFactory from '../services/clientFactory'
import produce from 'immer'

const initialState: UserState = {
    user: undefined
}

const initializeClientFactory = (memoryKey: string, botChecksum: string) => {
    // Update the Client configuration to access token and user id for memory for all future requests
    ClientFactory.setHeaders(() => {
        return { memoryKey, botChecksum }
    })
}

const userReducer: Reducer<UserState> = produce((state: UserState, action: ActionObject) => {
    switch (action.type) {
        case AT.FETCH_BOTINFO_FULFILLED:
            const user = action.botInfo.user
            initializeClientFactory(user.id, action.botInfo.checksum)
            state.user = user
            return
        default:
            return
    }
}, initialState)

export default userReducer


// WEBPACK FOOTER //
// ./src/reducers/userReducer.ts